<nav>
    @if(!isMenuOpen()){
    <div id="closed-menu">
        <a (click)="triggerScroll('landingPage')" id="logo" class="pointer">
            <img src="img/nav/logo-inverted.svg" alt="frontend developer">
        </a>

        <div id="desktop-links">
            <a (click)="triggerScroll('whyMe')"
                [class.active]="scrollService.activeSection() === 'whyMe'">{{contentService.content().mainPage.whyMe.title}}</a>
            <a (click)="triggerScroll('mySkills')"
                [class.active]="scrollService.activeSection() === 'mySkills'">{{contentService.content().mainPage.mySkillSet.title}}</a>
            <a (click)="triggerScroll('myWork')"
                [class.active]="scrollService.activeSection() === 'myWork'">{{contentService.content().mainPage.myWork.title}}</a>
            <a (click)="triggerScroll('contactSection')"
                [class.active]="scrollService.activeSection() === 'contactSection'">{{contentService.content().mainPage.contact.title}}</a>
        </div>

        <button id="menu-toggle" (click)="setMenu(true)">
            <img src="img/nav/burger-menu.svg" alt="Open Menu">
        </button>
    </div>
    }

    <div id=shadow-menu></div>
</nav>


@if(isMenuOpen()) {
<div id="mobile-overlay">
    <button class="close-toggle" (click)="setMenu(false)">
        <img src="img/nav/close.svg" alt="Close Menu">
    </button>

    <div id="mobile-links">
        <a (click)="triggerScroll('whyMe'); setMenu(false)">{{contentService.content().mainPage.whyMe.title}}</a>
        <a
            (click)="triggerScroll('mySkills'); setMenu(false)">{{contentService.content().mainPage.mySkillSet.title}}</a>
        <a (click)="triggerScroll('myWork'); setMenu(false)">{{contentService.content().mainPage.myWork.title}}</a>
        <a
            (click)="triggerScroll('contactSection'); setMenu(false)">{{contentService.content().mainPage.contact.title}}</a>
        <app-lang-switch [theme]="'dark'"></app-lang-switch>
    </div>
</div>
}

<div id="nav-placeholder"></div>